module.exports = __webpack_public_path__ + "static/media/exit.fecdbfe2.svg";